import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';

export const getRegion = regionId => {
  return Helpers.get(`${Constants.REGIONS_URL}/${regionId}`);
};

export const deleteRegion = regionId => {
  return Helpers.delete(`${Constants.REGIONS_URL}/${regionId}`, {});
};

export const getRegions = () => {
  return Helpers.get(Constants.REGIONS_URL);
};

export const saveRegion = region => {
  return Helpers.post(`${Constants.REGIONS_URL}`, {}, region);
};

export const getGroupsByRegion = regionId => {
  return Helpers.get(`${Constants.REGIONS_URL}/${regionId}/groups`);
};
